import httpClient from '@/api/http-client';
import getFormData from '@/util/form-data';

const endpoint = 'api/driving-permits-import';

const drivingPermitsImportService = {
  upload: (payload) => {
    const formData = getFormData(payload);

    return httpClient.post(`${endpoint}`, formData);
  },
};

export default drivingPermitsImportService;
